import { statusBadgeTones } from '@components/StatusBadge';

/**
 * Shared holiday domain constants - consumed by the Holidays settings tab
 * (form modal, list table) and the CSV/Excel import validator, so this
 * lives in `constants/` rather than a view's components folder.
 */
export const holidayTypes = {
  public: 'public',
  optional: 'optional',
};

export const HOLIDAY_TYPE_META = {
  [holidayTypes.public]: {
    label: 'Public Holiday',
    tone: statusBadgeTones.info,
  },
  [holidayTypes.optional]: {
    label: 'Optional Holiday',
    tone: statusBadgeTones.warning,
  },
};

export const HOLIDAY_TYPE_OPTIONS = Object.entries(HOLIDAY_TYPE_META).map(
  ([value, meta]) => ({ value, label: meta.label })
);

export const getHolidayType = (holiday) =>
  holiday?.optional ? holidayTypes.optional : holidayTypes.public;

export const HOLIDAY_DESCRIPTION_MAX_LENGTH = 150;
